import Head from "next/head";
import { useRouter } from "next/compat/router";

import { useSwrGet } from "@fwa/src/hooks/useSwrGet";
import { fwsUrSuperTeamPageSlug } from "@fwa/src/services/superTeamService";
import { JoinPage } from "@fwa/src/components/JoinPage";
import { ErrorPageWrapper } from "@fwa/src/components/ErrorPageWrapper";

import { type SuperTeamPageType } from "@fwa/src/types";
import { queryAsString } from "@fwa/src/utils/urlUtils";

const Page = () => {
  const router = useRouter();
  const { slug } = router?.query || {};
  const slugString = queryAsString(slug);
  const url = slugString.length
    ? `${fwsUrSuperTeamPageSlug({ slug: slugString })}`
    : null;
  const { data: pageData, error } = useSwrGet<SuperTeamPageType>(
    url?.length ? url : null,
  );
  const themeName = pageData
    ? pageData?.theme || pageData?.fundraisingPageType?.brand?.name
    : undefined;

  return (
    <ErrorPageWrapper error={error!}>
      {pageData ? (
        <>
          <Head>
            <title>Join {pageData.title}</title>
            <meta name="robots" content="noindex" />
          </Head>
          <JoinPage pageData={pageData} themeName={themeName} />
        </>
      ) : null}
    </ErrorPageWrapper>
  );
};

export default Page;
